/* global pinCampaignFormStrings */

export default class ErrorHandling {
  constructor() {
    this.state = {
      visualValidity: {},
      hiddenValidity: {},
      visualErrorCount: 0,
    };

    // is this in global.js?
    this.pinForm = document.querySelector('#pin-form');

    if (!this.pinForm) {
      return;
    }

    this.requiredInputs = this.pinForm.querySelectorAll(
      'input[required]:not([data-hidden-error])'
    );
    this.requiredHiddenInputs = this.pinForm.querySelectorAll(
      'input[required][data-hidden-error]'
    );

    this.setAllValidityStates();
  }

  setVisualValidityState() {
    this.requiredInputs.forEach((input) => {
      this.state.visualValidity[input.id] = input.validity;
    });
  }

  setHiddenValidityState() {
    this.requiredHiddenInputs.forEach((input) => {
      this.state.hiddenValidity[input.id] = input.validity;
    });
  }

  setAllValidityStates() {
    this.setVisualValidityState();
    this.setHiddenValidityState();
  }

  removeErrorMessages() {
    const errorMessages = document.querySelectorAll('.error-message');

    errorMessages.forEach((errorMessage) => {
      errorMessage.parentNode.removeChild(errorMessage);
    });
  }

  showErrorMessages() {
    this.state.visualErrorCount = 0;

    this.setAllValidityStates();
    this.removeErrorMessages();

    for (const key in this.state.visualValidity) {
      const validity = this.state.visualValidity[key];

      if (validity.valid) {
        continue;
      }

      const requiredInputsArray = [...this.requiredInputs];
      const [targetInput] = requiredInputsArray.filter(
        (input) => input.id == key
      );

      if (validity.valueMissing) {
        targetInput.insertAdjacentHTML(
          'afterend',
          `<p class="error-message error">${pinCampaignFormStrings.strings.blankError}</p>`
        );
      } else if (validity.typeMismatch) {
        targetInput.insertAdjacentHTML(
          'afterend',
          `<p class="error-message error">${pinCampaignFormStrings.strings.emailFormatError}</p>`
        );
      } else if (validity.patternMismatch) {
        targetInput.insertAdjacentHTML(
          'afterend',
          `<p class="error-message error">${pinCampaignFormStrings.strings.emailMismatchError}</p>`
        );
      }

      this.state.visualErrorCount++;
    }

    // Scroll back up to the first error message
    const firstErrorMessage = this.pinForm.querySelector('.error-message');
    if (firstErrorMessage) {
      firstErrorMessage.scrollIntoView({ behavior: 'smooth' });
    }
  }

  getHiddenErrorCount() {
    let hiddenErrorCount = 0;

    for (const key in this.state.hiddenValidity) {
      const validity = this.state.hiddenValidity[key];

      if (!validity.valid) {
        hiddenErrorCount++;
      }
    }

    return hiddenErrorCount;
  }

  getKlaviyoErrorString() {
    let errorString = '';

    for (const key in this.state.hiddenValidity) {
      const validity = this.state.hiddenValidity[key];

      if (!validity.valid) {
        if (key === 'date-of-birth') {
          errorString = `${errorString}${
            errorString.length ? ' & ' : ''
          }Underage`;
        }

        if (key === 'skill-test') {
          errorString = `${errorString}${
            errorString.length ? ' & ' : ''
          }Incorrect skill answer`;
        }
      }
    }

    return errorString;
  }
}
